import { computed, observable } from 'mobx';

import { autobind } from 'core-decorators';
import { useMount, useRequest } from 'ahooks';
import Service from '@src/business-components/news-swiper/service';
import AntdMessage from '@src/components/antd/message';
import useModal from '@src/utils/hooks/use-modal';
import MessageModal from '@src/business-components/news-swiper/components/message-modal';
import MessageModalStore from '@src/business-components/news-swiper/components/message-modal/store';

import { useRef } from 'react';
import { px2rem } from '@src/utils/rem-util';
import debounce from 'lodash.debounce';
import { $$tracker } from '@src/tracker';

class NewsSwiperStore {
  messageModalStore = new MessageModalStore();
  /**
   * 消息列表
   * @type {[]}
   */
  @observable messageList = [];

  @observable activeIndex = 0;

  @observable slideValue = 30;

  @observable lightBoxShowStatus = false;
  @observable currentLightBoxIndex = 0;
  @observable hasTransition = true;

  @computed
  get slideValueRem() {
    return px2rem(`${this.slideValue / 25.6}px`);
  }

  @computed
  get topRem() {
    if (this.activeIndex === 0) {
      return px2rem(`${0 / 25.6}px`);
    }
    return px2rem(`${(this.activeIndex * 101 - 99.99) / 25.6}px`);
  }

  /**
   * 是否展示列表
   * @returns {boolean}
   */
  @computed
  get isShowList() {
    return !!this.messageList.length;
  }

  @computed
  get isSwiperEnd() {
    return this.activeIndex === this.messageList.length - 1;
  }

  get isSwiperStart() {
    return this.activeIndex === 0;
  }

  constructor({ ...rest } = {}) {
    Object.assign(this, rest);
  }

  up = debounce(() => {
    if (this.activeIndex === this.messageList.length - 1) {
      return;
    }
    this.activeIndex = this.activeIndex + 1;
    if (this.activeIndex > 0) {
      this.slideValue = this.slideValue - 101;
    }
  }, 150);

  down = debounce(() => {
    if (this.activeIndex === 0) {
      return;
    }
    this.activeIndex = this.activeIndex - 1;
    if (this.activeIndex < this.messageList.length) {
      if (this.activeIndex === 0) {
        this.slideValue = 30;
      } else {
        this.slideValue = this.slideValue + 101;
      }
    }
  }, 150);

  @autobind
  async init() {
    try {
      const res = await this.getNewsListRequest.run();
      this.messageList = res.list;
    } catch (err) {
      AntdMessage.error(err.message);
    }
  }

  @autobind
  onMessageItemClick(item) {
    // this.currentLightBoxIndex = key;
    this.lightBoxShowStatus = true;
    this.messageModalStore.messageImg = item.message_img;
    this.messageModalStore.mode = item.img_mode * 1;
    // this.messageModal.open({ extraProps: { store: this.messageModalStore } });
    $$tracker.clickMESSAGE();
  }

  use() {
    this.swiperContainerRef = useRef(null);
    this.getNewsListRequest = useRequest(async () => await Service.getServiceAsync(), {
      manual: true,
      throwOnError: true
    });
    this.messageModal = useModal(MessageModal);

    useMount(() => {
      // this.init();
      // this.onMessageItemClick(this.messageList[0]);
    });
  }
}

export default NewsSwiperStore;
